module.exports = {
  SERVER: 'https://api.thegiftguide.com/api',
  APPLINK: 'https://www.thegiftguide.com'
};
